module.exports = __webpack_public_path__ + "static/img/dpksh.9f3f50e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/dpksh.jpg
// module id = LUBp
// module chunks = 1